module.exports = __webpack_public_path__ + "static/media/export.f2832b97.svg";